export function clusterByDistance(points, radius) {
  const clusters = []
  const claimed = new Set()

  points.forEach((seed, seedIndex) => {
    if (claimed.has(seedIndex)) return
    claimed.add(seedIndex)

    const members = [seed]
    points.forEach((candidate, candidateIndex) => {
      if (claimed.has(candidateIndex)) return
      if (pixelDistance(seed, candidate) > radius) return

      claimed.add(candidateIndex)
      members.push(candidate)
    })

    clusters.push(members)
  })

  return clusters
}

export function centroid(points) {
  const total = points.reduce(
    (sum, point) => ({ lat: sum.lat + point.lat, lng: sum.lng + point.lng }),
    { lat: 0, lng: 0 }
  )
  return {
    lat: total.lat / points.length,
    lng: total.lng / points.length,
  }
}

function pixelDistance(a, b) {
  return Math.hypot(a.x - b.x, a.y - b.y)
}
